export const DEFAULT_LANGUAGE = 'uk';
